// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1csaF","visuallyhidden":"_2Rjel","hide-text":"E0RgG","center":"iymdr","noprint":"_1Hplx","editorial-label":"kd0dU"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-editorial-label/styles/default.scss
 ** module id = 994
 ** module chunks = 2
 **/